const variableValueTypes = {
    NUMBER: 'Number',
    PERCENT: 'Percent',
};

export default variableValueTypes;
